import shapefileUploadDialogSlice from './shapefileUploadDialogSlice';

const dialogsSlices = [shapefileUploadDialogSlice];

export default dialogsSlices;
